import type { Database } from "@/integrations/supabase/types";

export type AccountRole = Database["public"]["Enums"]["account_role"];

export const hasAccountRole = (
  roles: readonly AccountRole[],
  requiredRole: AccountRole,
) => roles.includes(requiredRole);
